"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sackurTetrodeDependencies = void 0;

var _dependenciesBigNumberClassGenerated = require("./dependenciesBigNumberClass.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var sackurTetrodeDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated.BigNumberDependencies,
  createSackurTetrode: _factoriesAny.createSackurTetrode
};
exports.sackurTetrodeDependencies = sackurTetrodeDependencies;